<template>
  <div class="container-sm" style="padding-top: 1rem;">
 <div class="case-creation__step case-creation__Case-information">    
    <div class="case-creation__card">
      <div class="case-creation__heading ">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-case-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Settings</h3>
        </div>
      </div>
      <div class="case-creation__body" v-loading="loading">
        <div class="vue-data">
          <el-row :gutter="15">
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div
                class="input-value"
              >
                <h4 class="name">First Name</h4>
                <p
                  class="value"
                  >{{commercialSettingsData.first_name || "--"}}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">Last Name</h4>
                <p
                  class="value"
                  >{{commercialSettingsData.last_name || "--"}}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">Phone</h4>
                <p
                  class="value"
                  >{{commercialSettingsData.phone || "--"}}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">Platform</h4>
                <p
                  class="value"
                  >{{commercialSettingsData.platform?.[0] || "--"}}
                </p>
              </div>
            </el-col>
            <el-col :xl="5" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">Status</h4>
                <div style="display: flex;align-items: center; column-gap: 10px;">
                <p
                  class="value"
                  >{{commercialSettingsData.status || "--"}}
                </p>
                <el-switch
                  v-if="commercialSettingsData._id"
                  :model-value="switchStatus"
                  active-value="ACTIVE"
                  inactive-value="INACTIVE"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="updateStatus"
                ></el-switch>
                </div>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">User Type</h4>
                <p
                  class="value"
                  >{{commercialSettingsData?.user_type?.replaceAll('_', ' ') || "--"}}
                </p>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">Email</h4>
                <p
                  class="value"
                  >{{commercialSettingsData.email || "--"}}
                </p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value">
                <h4 class="name">Created At</h4>
                <p
                  class="value"
                  >
                  {{
                    momentWithTimezoneTime(
                      commercialSettingsData.created_at,
                      "MM-DD-yyyy"
                    ) || "--"
                  }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
  </div>
  </template>
  <script>
  import { mapGetters } from "vuex";
  export default {
    computed: {
      ...mapGetters("insurances", ["getCommercialInsuranceSettings","getUpdateMedicalGroupStatus"]),
    },
    mounted() {
      this.fetchInsurancesSettings();
    },
    data() {
      return {
        loading: false,
        commercialSettingsData: {},
        switchStatus: "",
      };
    },
    methods: {
      async updateStatus(value) {
        try {
          this.loading = true;
          await this.$store.dispatch("insurances/updateCommercialInsuranceSettings");
          if (this.getUpdateMedicalGroupStatus) {
            this.switchStatus = value;
            this.commercialSettingsData.status = value;
            this.$message.success("Status updated successfully");
          } else {
            this.$message.error("Failed to update status");
          }
          this.loading = false;
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      },
      async fetchInsurancesSettings() {
        try {
          this.loading = true;
          await this.$store.dispatch("insurances/fetchCommercialInsuranceSettings");
          this.commercialSettingsData = JSON.parse(JSON.stringify(this.getCommercialInsuranceSettings));
          this.switchStatus = this.commercialSettingsData.status;
          this.loading = false;
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped> 
 .input-value{
  margin-bottom: 10px;
 }
 .input-value .value {
    color: #0a2342;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    overflow-wrap: break-word;
}
 .input-value .name {
    font-size: 15px;
    color: rgb(148, 126, 126);
    font-weight: 500;
    display: block;
    margin-bottom: 2px;
}

</style>